import { AlertCircle, AlertTriangle } from 'lucide-react';

import { ErrorClass } from '@/platform-status/entities/platform-component';
import { errorClassTextColor } from '@/platform-status/utils/error-class';
import { cls } from '@/utils/cls';

export type ErrorClassIconProps = {
  errorClass: ErrorClass;
};

export function ErrorClassIcon({ errorClass }: ErrorClassIconProps) {
  switch (errorClass) {
    case ErrorClass.ERROR_CLASS_1: {
      return (
        <AlertTriangle
          className={cls('size-4', errorClassTextColor[errorClass])}
        />
      );
    }
    case ErrorClass.ERROR_CLASS_2: {
      return (
        <AlertCircle
          className={cls('size-4', errorClassTextColor[errorClass])}
        />
      );
    }
  }
}
